import React, { useRef, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import { MenuItems } from "./ResponseButtonWithMenu.tsx";
import SchedulingInterface, { SchedulingInterfaceHandle } from "./scheduling/SchedulingInterface.tsx";
import { apiService } from "../services/api";

const EllipsisButton = ({
  handleDeleteLead,
  lead,
  isMobileView,
  handleChangeLeadData,
  handleClearChat,
}) => {
  const [anchorEllipsis, setAnchorEllipsis] = useState(null);
  const openEllipsis = Boolean(anchorEllipsis);
  const schedulerRef = useRef<SchedulingInterfaceHandle | null>(null);
  const handleClickEllipsisMenu = (event) => {
    setAnchorEllipsis(event.currentTarget);
  };
  const handleCloseEllipsisMenu = () => {
    setAnchorEllipsis(null);
  };

  const handleConvertLead = async () => {
    try {
      handleCloseEllipsisMenu();
      if (!lead?.id) return;
      await (apiService as any).convertLead(lead.id);
      if (handleChangeLeadData) {
        await handleChangeLeadData(lead.id, "stage", "converted");
        await handleChangeLeadData(lead.id, "status", "converted");
      }
    } catch (e) {
      console.error("Failed to convert lead", e);
      alert("Failed to mark lead as converted. Please try again.");
    }
  };

  const handleDeleteChat = async () => {
    try {
      handleCloseEllipsisMenu();
      if (!lead?.id) return;
      await (apiService as any).deleteChat(lead.id);
      // Only clear chat content; do not remove the lead from the list/right pane
      if (typeof handleClearChat === "function") handleClearChat();
    } catch (e) {
      console.error("Failed to delete chat", e);
      alert("Failed to delete chat. Please try again.");
    }
  };

  return (
    <>
      <Button
        id="ellipsis-button"
        onClick={handleClickEllipsisMenu}
        aria-controls={openEllipsis ? "elipsis-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openEllipsis ? "true" : undefined}
        sx={{
          minWidth: "40px",
          width: "40px",
          height: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 0,
          border: `${openEllipsis ? "1px" : "none"} solid`,
          borderColor: "lightGray",
          borderRadius: "50%",
          "&:hover": {
            backgroundColor: "lightestBlue",
            boxShadow: "none",
          },
        }}
      >
        <i className="fa-solid fa-ellipsis-vertical text-darkestSlate"></i>
      </Button>
      <Menu
        id="ellipsis-menu"
        anchorEl={anchorEllipsis}
        open={openEllipsis}
        onClose={handleCloseEllipsisMenu}
        MenuListProps={{
          "aria-labelledby": "basic-button",
          sx: {
            paddingTop: 0,
            paddingBottom: 0,
          },
        }}
        elevation={0}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            width: isMobileView ? "calc(100vw - 100px)" : "200px",
            maxWidth: "350px",
            borderRadius: "8px",
            border: "1px solid #222830",
            background: "#F3F5F7",
            boxShadow: "0 4px 24px #CBD5E066",
            transform: "translateY(10px)",
          },
        }}
      >
        <MenuItem
          onClick={() => {
            handleCloseEllipsisMenu();
            schedulerRef.current?.open();
          }}
          sx={{
            fontFamily: "Inter , sans-serif",
            fontSize: "16px",
            fontWeight: "600",
            color: "#222830",
            padding: "15px",
          }}
        >
          Schedule Meeting
        </MenuItem>
        <Divider sx={{ margin: "0 !important", borderColor: "#323C48" }} />
        <MenuItem
          onClick={handleConvertLead}
          sx={{
            fontFamily: "Inter , sans-serif",
            fontSize: "16px",
            fontWeight: "600",
            color: "#222830",
            padding: "15px",
          }}
        >
          Mark Lead Converted
        </MenuItem>
        <Divider sx={{ margin: "0 !important", borderColor: "#323C48" }} />
        <MenuItem
          onClick={handleDeleteChat}
          sx={{
            fontFamily: "Inter , sans-serif",
            fontSize: "16px",
            fontWeight: "600",
            color: "#222830",
            padding: "15px",
          }}
        >
          Delete Chat
        </MenuItem>

        {isMobileView && (
          <>
            <Divider sx={{ margin: "0 !important", borderColor: "#323C48" }} />
            <MenuItems
              lead={lead}
              handleChangeLeadData={handleChangeLeadData}
              handleCloseResponseMenu={handleCloseEllipsisMenu}
            />
          </>
        )}
      </Menu>
      {/* Scheduler instance controlled via ref; renders only when opened */}
      <SchedulingInterface ref={schedulerRef} leadId={lead?.id} showTriggerButton={false} />
    </>
  );
};

export default EllipsisButton;
